export default __webpack_public_path__ + "static/media/snow3.a14cca83.png";